/**
 * Hostnames on which ReČeK runs as a non-production (test/development) instance.
 *
 * This allow-list is the single source of truth for "is this a test environment?"
 * decisions across the fork (test-version banner, debug tooling, ...).
 */
export var TEST_ENV_HOSTNAMES = [
    'localhost',
    'recek-vyvoj.tritius.cz',
    'recek-test.tritius.cz',
    // k8s (Eureka) test/dev instances — the app moved to these hostnames (DB-326)
    'recek.dev.tritius.cz',
    'recek.test.tritius.cz',
];
/**
 * Returns `true` when the app is served from a known test/development hostname,
 * i.e. NOT production. Used to gate visibility of test-only UI such as the
 * test-version banner and the debug-info tooling.
 */
export var isTestEnvironment = function () {
    return TEST_ENV_HOSTNAMES.includes(window.location.hostname);
};
